import React from 'react';

import * as d3 from 'd3';
import * as d3Shape from 'd3-shape';

class Donut extends React.Component {
    updateChart() {
        const data = this.props.data || [];

        let arc = d3Shape
            .arc()
            .outerRadius(50)
            .innerRadius(33);
        let pie = d3Shape
            .pie()
            .sort(null)
            .value(function(d) {
                return d.count;
            });

        let svg = d3.select(this.svgElement);
        let bg = svg.append('g').attr('transform', 'translate(50, 50)');
        bg.selectAll('.arc')
            .data(pie([{ name: 'bg', count: 100 }]))
            .enter()
            .append('g')
            .attr('class', 'arc bg')
            .append('path')
            .attr('d', arc);
        let donut = svg.append('g').attr('transform', 'translate(50, 50)');
        donut
            .selectAll('.arc')
            .data(pie(data))
            .enter()
            .append('g')
            .attr('class', d => {
                return `arc ${d.data.name} status-${d.data.criticality}`;
            })
            .append('path')
            .attr('d', arc);
    }

    componentDidMount() {
        this.updateChart();
    }

    componentDidUpdate() {
        this.updateChart();
    }

    render() {
        const data = this.props.data || [];
        let totalCount = 0;
        data.forEach(datum => {
            totalCount += datum.count;
        });

        return (
            <div className="Donut">
                <svg viewBox="0 0 100 100" ref={el => (this.svgElement = el)} />
                <div>
                    <p>
                        <span className="count">{totalCount}</span>
                        <span className="label">Ready</span>
                    </p>
                </div>
            </div>
        );
    }
}

export default Donut;
